import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import moment from 'moment';
import {
    HelpBlock,
    FormGroup,
    ControlLabel} from 'react-bootstrap';
import isDefined from '../utils/isDefined';
import AdditionalInfoComponentC from './AdditionalInfoComponent';
import { isEmpty } from 'lodash';
import { getStateName } from '../utils/getState';

import TooltipContainer from './Tooltip';
import { Async } from 'react-select';
import uuidv4 from 'uuid/v4';
import { getCurrentSession } from '../../../../../lib/authentication';

export class GoogleAddressSearchContainer extends React.PureComponent {
    constructor(props) {
        super(props);
        const name = this.props.data.name;
        const initialValue = this.props.initialValues[name];

        this.autocomplete = null;
        this.componentForm = {
            street_number: "short_name",
            route: "long_name",
            locality: "long_name",
            sublocality: "long_name",
            administrative_area_level_1: "long_name",
            administrative_area_level_2: "long_name",
            postal_code: "short_name",
            neighborhood: "long_name",
        };

        this.state = {
            value: isDefined(initialValue) ? initialValue : '',
            disabled:
                this.props.initialParams[name] && this.props.initialParams[name].disabled
                    ? this.props.initialParams[name].disabled
                    : false,
            isValid: null,
            validationMessage: '',
            sessionToken: uuidv4(),
        };

        if (isDefined(initialValue) && this.props.data.inputFormat === 'date') {
            this.state.value = moment(this.state.value)
                .format('MM/DD/YYYY')
        }

        this.handleChange = this.handleChange.bind(this);
        this.getValidationState = this.getValidationState.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handlePlaceChange = this.handlePlaceChange.bind(this);
        this.handleFocus = this.handleFocus.bind(this);
        this.loadOptions = this.loadOptions.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
    }

    componentDidMount() {
        const element = document.getElementById(this.props.data.name);
        if (element) {
            element.setAttribute('autocomplete', true);
        }
    }

    componentDidUpdate(_prevProps, _prevState, _snapshot) {
        const element = document.getElementById(this.props.data.name);
        if (element && element.getAttribute('autocomplete')) {
            element.setAttribute('autocomplete', true);
        }
    }

    handlePlaceChange(place, description) {
        const isUnderwriter = this.props.isUnderwriter;
        const authStates = this.props.authStates;
        const stateRestrict = !!this.props.data.stateRestriction;
        let address = {};
        for (const component of place.address_components) {
            for (let i=0; i<component.types.length; i++) {
                const addressType = component.types[i];
                if (this.componentForm[addressType]) {
                    const val = component[this.componentForm[addressType]];
                    address[addressType] = !!val ? val : '';
                    break;
                }
            }
        }

        let transformedAddress = {};
        if (!!address['street_number'] && !!address['route']) {
            transformedAddress['address'] = address['street_number'] + ' ' + address['route'];
        } else if (!!address['street_number']) {
            transformedAddress['address'] = address['street_number'];
        } else if (!!address['route']) {
            transformedAddress['address'] = address['route'];
        } else {
            if (description.includes(",")) {
                transformedAddress['address'] = description.split(",")[0];
            } else {
                transformedAddress['address'] = description ? description : '';
            }
        }
        if (!!address['sublocality'] && address['administrative_area_level_1']=="New York") {
            if (address['sublocality']=="Queens" && address['neighborhood'])
            transformedAddress['city'] = address['neighborhood'];
            else
            transformedAddress['city'] = address['sublocality'];
        }
        else {
        if (!!address['locality']) {
            transformedAddress['city'] = address['locality'];
        } else if (!!address['sublocality']) {
            transformedAddress['city'] = address['sublocality'];
        } else if (!!address['neighborhood']) {
            transformedAddress['city'] = address['neighborhood'];
        } else if (!!address['administrative_area_level_2']) {
            transformedAddress['city'] = address['administrative_area_level_2'];
        } else {
            transformedAddress['city'] = '';
        }
    }

        transformedAddress['state'] = address['administrative_area_level_1'] ? address['administrative_area_level_1'] : '';
        transformedAddress['zipcode'] = address['postal_code'] ? address['postal_code'] : '';
        const autofillFields = this.props.data.autofillFields;
        let addressValues = {};

        const stateName = getStateName(transformedAddress['state']);
        let stateRestrictValues = false;
        if (!isUnderwriter && authStates && authStates.length >= 0 && !authStates.includes(stateName)) {
            stateRestrictValues = stateRestrict;
        }
        Object.keys(transformedAddress).forEach(field => {
            addressValues[autofillFields[field]] = (field !== 'address' && stateRestrictValues) ? '' : transformedAddress[field];
        });
        this.props.handleAddressChange(addressValues, stateRestrictValues, stateName);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props !== nextProps && !isEmpty(nextProps.addressValues)) {
            const name = nextProps.data.name;
            const initialValue = nextProps.addressValues[name];
            if (initialValue || initialValue === '') {
                this.setState({
                    value: isDefined(initialValue) ? initialValue : ''
                })
            }
        }
    }

    getValidationState() {
        // this bit of code acts as a circuit breaker
        // We want get validation to trigger
        // a validation function and when results are back we need to call it again
        // But this breaks the loops
        if (this.state.isValid) {
            const isValid = this.state.isValid;
            this.state.isValid = null;
            return isValid;
        }

        // only trigger validation if the value changes
        if (
            this.state.value !== '' &&
            this.props.data.attributes &&
            this.props.data.attributes.validationFunc &&
            this.props.validation[this.props.data.attributes.validationFunc]
        ) {
            this.props.validation[this.props.data.attributes.validationFunc](
                this.props.data.name,
                this.state.value
            ).then(result => {
                this.setState({
                    isValid: result.status ? 'success' : 'error',
                    validationMessage: result.status ? '' : result.message
                });
            });
        }

        if (this.state.isValid !== null) {
            return this.state.isValid;
        }

        return;
    }

    handleChange(event) {
        if (event === null) {
            this.setState({ value: '' });
            return;
        }
        if (event.value === -1) {
            let option = { target: { value: event.label } };
            this.handleBlur(option);
            return;
        }
        const placeID = event.value;
        const placeDescription = event.label;
        const query = null;
        const isPlaceSelected = true;
        const params = {
            query,
            isPlaceSelected,
            placeID,
            sessionToken: this.state.sessionToken,
        };
        const apiClient = apigClientFactory.newClient();
        getCurrentSession().then(({ idToken }) =>
            apiClient
                .apiGetAddressAutoCompleteGet(params, {}, { headers: { Authorization: idToken } })
                .then((place) => {
                    this.handlePlaceChange(place.data.result, placeDescription)
                })
                .catch((err) => console.log(err)),
            )

        this.setState({ sessionToken: uuidv4() });
    }

    handleBlur(event) {
        const value = event.target.value;

        if (!value) {
            return;
        }
        this.setState({ value });
        this.props.handleFormChange();
        if (this.props.addressValues) {
            let updatedValue = {};
            updatedValue[this.props.data.name] = value;
            const addressValues = Object.assign({}, this.props.addressValues, updatedValue);
            this.props.handleAddressChange(addressValues);
        }
    }

    handleFocus(event) {
        event.target.setAttribute('autocomplete', true);
    }

    handleDateChange(event) {
        this.props.handleFormChange();
        this.setState({ value: event.target.value });
    }

    loadOptions(inputValue) {
        const query = inputValue;
        const isPlaceSelected = false;
        const placeID = null;
        const params = {
            query,
            isPlaceSelected,
            placeID,
            sessionToken: this.state.sessionToken,
        };
        const apiClient = apigClientFactory.newClient();
        return getCurrentSession().then(({ idToken }) =>
            apiClient
                .apiGetAddressAutoCompleteGet(params, {}, { headers: { Authorization: idToken } })
                .then((data) => {
                    const options = data.data.result.map((place) => ({
                        value: place.place_id,
                        label: place.description,
                    }))
                    const google_logo = (
                        <div className="logo-holder">
                        <div className="google-logo" />
                        </div>
                    )

                    options.push({
                        label: google_logo,
                        value: `${inputValue}_googleLogo`,
                        disabled: true,
                    })

                    if (inputValue) {
                        options.unshift({
                        label: inputValue,
                        value: -1,
                        className: 'hide-option',
                        })
                    }

                    return { options }
                })
                .catch((err) => console.log(err)),
            )
        }

    render() {

        let selectedOption = {
            label: this.state.value,
            value: this.state.value,
        };
        if (this.state.value === '') {
            selectedOption = null;
        }
        let input;
        var classNamesInput = classNames({
            mandatoryField: this.props.data.required,
            requiredLabel: (!this.state.value && this.props.requiredLabel),
            'placeholder-tooltip-hidden': this.props.data.placeholderHidden,
            'placeholder-tooltip-exposed': this.props.data.placeholderExposed && !this.props.data.placeholderHidden,
            'placeholder': !this.props.data.placeholderHidden && !this.props.data.placeholderExposed
        });

        input = (
            <div className="address-search">
                {this.props.data.placeholder && (
                    <label className={classNamesInput}>{this.props.data.placeholder}</label>
                )}
                <Async
                    cacheOptions
                    loadOptions={this.loadOptions}
                    id={this.props.data.name}
                    onChange={this.handleChange}
                    value={selectedOption}
                    autoComplete={true}
                    onBlur={this.handleBlur}
                    filterOptions={false}
                    onCloseResetsInput={true}
                    deleteRemoves={true}
                    placeholder=""
                    ignoreCase = {false}
                    disabled = {this.props.isSameAddress && this.props.data.questionId== "3a" && this.props.addressValues}
                />
            </div>
        );

        const helpBlock =
            this.state.isValid === 'error' ? (
                <HelpBlock>{this.state.validationMessage}</HelpBlock>
            ) : null;
        return (
            <FormGroup validationState={this.getValidationState()} controlId={this.props.data.name}>
                <div className="label-container">
                    {this.props.data.text && <ControlLabel className={classNames({ 'mandatoryField': this.props.data.required })}>{this.props.data.text}</ControlLabel>}
                    <TooltipContainer data={this.props.data} />
                </div>

                {input}
                {this.props.data.helper && <div className="helper">{this.props.data.helper}</div>}

                {helpBlock}
                <AdditionalInfoComponentC
                    additionalInfo1Color={this.props.data.additionalInfo1Color}
                    additionalInfo1={this.props.data.additionalInfo1}
                    additionalInfo2={this.props.data.additionalInfo2}
                    additionalInfoIcon={this.props.data.additionalInfoIcon}
                />
            </FormGroup>
        );
    }
}

GoogleAddressSearchContainer.propTypes = {
    data: PropTypes.object.isRequired,
    handleFormChange: PropTypes.func.isRequired,
    validation: PropTypes.object.isRequired,
    initialValues: PropTypes.object.isRequired,
    initialParams: PropTypes.object.isRequired
};

export default GoogleAddressSearchContainer;
